const init = {
    height: 500,
    menubar: false,
    content_style: "@import url('https://fonts.googleapis.com/css?family=Poppins:wght@100;200;300;400;500;600;700&display=swap'); body { font-family: 'Poppins', sans-serif; } " + "p { margin: 0; }",
    extended_valid_elements: "script[language|type|async|src|charset]" + "blockquote[dir|style|cite|class|id|lang|onclick|ondblclick|data-instgrm-captioned|data-instgrm-permalink|data-instgrm-version]",
    plugins: [
      "advlist autolink lists link image charmap print preview anchor",
      "searchreplace visualblocks code fullscreen",
      "insertdatetime media table paste code help wordcount",
      "table",
      "image code",
      "link",
    ],
    toolbar:
      "undo redo | fontsizeselect formatselect | bold italic underline backcolor | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | Link |  \
      table | image media | removeformat |\
      | help",
    fontsize_formats: "10px 12px 14px 16px 18px 24px 36px",
    image_title: true,
    automatic_uploads: true,
    file_picker_types: "image",
    file_picker_callback: function (cb) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.onchange = function () {
        const file = this.files[0];
        const reader = new FileReader();
        reader.onload = function (e) {
          cb(e.target.result, {title: file.name});
        };
        reader.readAsDataURL(file);
      };
      input.click();
    },
  }

  const key = 'bsun9fo9cxywkolhye1uu0kxbhxzmmlpybyk3jn02n93lxiu'

  module.exports = {init, key};
